import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { AppComponent } from "./app.component";
import { DefaultLayoutComponent } from "./containers";
import { P404Component } from "./views/error/404.component";
import { P500Component } from "./views/error/500.component";
import { LoginComponent } from "./views/login/login.component";
import { QuotationPolicyComponent } from "./views/quotation-policy/quotation-policy.component";
import { QuotationRoadTaxComponent } from "@views/quotation-road-tax/quotation-road-tax.component";
import { PaymentComponent } from "@views/payment/payment.component";


// Import routing module
import { AppRoutingModule } from "./app.routing";

// Import 3rd party components
import { httpInterceptorProviders } from "./interceptors";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { en_US, NZ_I18N } from "ng-zorro-antd/i18n";
import { NgxSpinnerModule } from "ngx-spinner";
import { NzSelectModule  } from "ng-zorro-antd/select";
import { NzInputNumberModule  } from "ng-zorro-antd/input-number";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzStepsModule  } from "ng-zorro-antd/steps";
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzRadioModule  } from "ng-zorro-antd/radio";
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NgOptimizedImage } from "@angular/common";
import { environment } from "@environments/environment";
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NgxMaskConfig, provideEnvironmentNgxMask  } from 'ngx-mask'

import { NzTabsModule } from 'ng-zorro-antd/tabs';

const APP_CONTAINERS = [DefaultLayoutComponent];

const maskConfig: Partial<NgxMaskConfig> = {
  validation: false,
};

@NgModule({ declarations: [
        AppComponent,
        ...APP_CONTAINERS,
        P404Component,
        P500Component,
        LoginComponent,
        QuotationPolicyComponent,
        QuotationRoadTaxComponent,
        PaymentComponent
    ],
    bootstrap: [AppComponent], imports: [
        NgxSpinnerModule ,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        NzCheckboxModule,
        NzStepsModule,
        NzCardModule,
        NzRadioModule,
        NzInputNumberModule,
        NgxSpinnerModule,
        NzDatePickerModule,
        NzPopoverModule,
        RecaptchaV3Module,
        NzSelectModule,
        NzModalModule,
        NzCollapseModule,
        NzTableModule,
        NzTabsModule,
        NzIconModule,
        NgOptimizedImage], providers: [
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy,
        },
        httpInterceptorProviders,
        { provide: NZ_I18N, useValue: en_US },
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: environment.recaptcha.siteKey,
        },
        provideEnvironmentNgxMask(maskConfig),
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
